// extracted by mini-css-extract-plugin
export default {"ringContainer":"PromptIco_ringContainer__ALCjQ","circle":"PromptIco_circle__BWtZF","ringring":"PromptIco_ringring__AZpWB","pulsate":"PromptIco_pulsate__IzlXn"};